import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { LockKeyhole } from 'lucide-react';
export function SecretSection() {
  return <section className="py-24 bg-navy-950 relative overflow-hidden" data-id="element-179">
      {/* Cyber-financial aesthetic background elements */}
      <div className="absolute inset-0 opacity-[0.03] font-mono text-xs overflow-hidden text-green-500 break-all leading-none select-none pointer-events-none" data-id="element-180">
        {Array.from({
        length: 100
      }).map(() => '01001101 01101111 01101110 01100101 01111001 ').join('')}
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-181">
        <FadeIn className="bg-navy-900 border border-navy-700 p-8 md:p-12 rounded-2xl relative" data-id="element-182">
          <div className="absolute top-0 right-8 -translate-y-1/2 bg-navy-950 px-4 border border-navy-700 rounded-full flex items-center gap-2 text-gold-500/70 text-sm font-mono" data-id="element-183">
            <LockKeyhole className="w-4 h-4" data-id="element-184" />
            <span data-id="element-185">ACCESO RESTRINGIDO</span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif" data-id="element-186">
            Lo que el banco{' '}
            <span className="text-gold-400 italic" data-id="element-187">no quiere que sepas.</span>
          </h2>

          <div className="space-y-6 text-lg text-gray-300 font-light" data-id="element-188">
            <p data-id="element-189">
              Existe una ley federal que te protege. Existen errores en tu
              reporte que te están costando miles de dólares al año. Ellos no te
              lo van a decir, porque tu ignorancia es su ganancia.
            </p>
            <div className="p-6 bg-navy-950/50 border-l-2 border-gold-500 rounded-r-lg" data-id="element-190">
              <p className="font-medium text-white" data-id="element-191">
                Descubre el protocolo de borrado de errores y recupera tu poder
                de compra en 90 días.
              </p>
            </div>
            <p className="text-gold-400/80 font-serif text-xl italic" data-id="element-192">
              El conocimiento es el único escape.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}